<div class="catchment-table-header">
  <div class="header">
    <h4 i18n="@@catchmentsHeader">
      Catchments
      <span> {{ selectedCountLabel }} </span>
    </h4>
    @if ( dataSource && dataSource.length > 0 && !areMultipleLocationsSelected )
    {
    <mat-checkbox
      [checked]="allSelected"
      [indeterminate]="someSelected"
      [disabled]="dataSource && dataSource.length <= 1"
      (change)="setAll($event.checked)"
      i18n="@@selectAllCheckbox"
    >
      Select all
    </mat-checkbox>
    }
  </div>
  <mat-divider></mat-divider>
</div>

@if (!areMultipleLocationsSelected) {
<div>
  @if (dataSource.length === 0) {
  <div class="empty-list" i18n="@@noCatchmentsMessage">
    There are currently no catchments associated with this location.
  </div>
  }
  <mat-divider></mat-divider>
</div>
}

<div class="table-container">
  @if (dataSource && dataSource.length > 0) {
  <table mat-table [dataSource]="dataSource" class="catchment-table">
    <ng-container matColumnDef="type">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="first-column-width"
        i18n="@@typeColumn"
      >
        Type
      </th>
      <td (click)="onClick(element)" mat-cell *matCellDef="let element">
        @if (element.type === locatorShapeTypes.Circle) {
        <div
          matListItemIcon
          class="atlas-icon icon-circle padding-circle"
        ></div>
        } @if (element.type === locatorShapeTypes.Car) {
        <mat-icon matListItemIcon> directions_car </mat-icon>
        } @if (element.type === locatorShapeTypes.Walk) {
        <mat-icon matListItemIcon> directions_walk </mat-icon>
        } @if (element.type === locatorShapeTypes.PublicTransport) {
        <mat-icon matListItemIcon> train </mat-icon>
        } @if (element.type === locatorShapeTypes.FreeForm) {
        <span class="material-symbols-outlined freeform-position">
          activity_zone
        </span>
        } @if (element.type === locatorShapeTypes.FreeFormLocked) {
        <span class="material-symbols-outlined freeform-position">
          activity_zone
        </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="column-width description-align"
        i18n="@@descriptionColumn"
      >
        Description
      </th>
      <td
        (click)="onClick(element)"
        mat-cell
        *matCellDef="let element"
        class="description-align truncate-description"
      >
        {{ element.name | translate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="last-column-width"></th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          (click)="onDelete(element)"
          class="delete-icon"
          [disabled]="isCatchmentReportingReadonlySystem$ | async"
          i18n-aria-label="@@deleteButtonAriaLabel"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="{ highlighted: selection.isSelected(row) }"
    ></tr>
  </table>
  }
</div>
